import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IPublishedConnectionTable } from '../types/IPublishedConnectionTable';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';

export interface IGetPublishedConnectionTablesParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionTablesResult extends IGetItemsResult {
  publishedConnectionTables?: IPublishedConnectionTable[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionTablesRequest extends Request<IGetPublishedConnectionTablesParams, IGetPublishedConnectionTablesResult> {
  constructor(params: IGetPublishedConnectionTablesParams) {
    super('getPublishedConnectionTables', params);
  }
}
